import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { Nullable } from 'corgi-types';
import { space, textAlign } from 'styled-system';

import PartNumbers from './PartNumbers';
import Pictures from './Pictures';
import VendorOrderId from './VendorOrderId';

export interface AdditionalInfoSectionProps {
  partNumbers: string[];
  resources: string[];
  vendorOrderId: Nullable<string>;
}

const UnstyledContainer = styled.div<any>`
  ${textAlign};
`;

const Container = (props: ComponentProps<typeof UnstyledContainer>) => (
  <UnstyledContainer textAlign="left" {...props} />
);

const StyledPartNumbers = styled(PartNumbers)<any>`
  ${space};
`;

const AdditionalInfoSection = ({
  partNumbers,
  resources,
  vendorOrderId,
}: AdditionalInfoSectionProps) => (
  <Container>
    <VendorOrderId vendorOrderId={vendorOrderId} />
    <StyledPartNumbers
      items={partNumbers}
      mt={!!vendorOrderId?.length && 'sp_8'}
      mb={!!resources.length && 'sp_8'}
    />
    <Pictures items={resources} />
  </Container>
);

export default AdditionalInfoSection;
